import { createSlice } from '@reduxjs/toolkit';

// Define an initial state
const initialState = {
    accessToken: "",
    adminInfo: null,
};


const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {

        // This function sets the access token
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        // This function removes the access token
        removeAccessToken: (state) => {
            state.accessToken = "";
        },

        setadminInfo: (state, action) => {
            state.adminInfo = action.payload;
        },
        removeadminInfo: (state) => {
            state.adminInfo = null;
        },
    },
});

// Export the action creators
export const { setAccessToken, removeAccessToken, setadminInfo, removeadminInfo } = authSlice.actions;
export { authSlice };